import type { ConceptDef } from '../types';

export const tactPictures: ConceptDef = {
  kind: 'supervisorScored',
  id: 'tact-pictures',
  label: 'Expressive Pictures',
  category: 'Expressive',
  description: 'Show a picture; learner names it. Supervisor scores.',
  config: {
    promptMode: 'TEXT',
    prompts: [
      { prompt: '🍎 apple' },
      { prompt: '🐶 dog' },
      { prompt: '🚗 car' },
      { prompt: '🌳 tree' },
      { prompt: '⚽ ball' },
      { prompt: '🎂 cake' },
      { prompt: '📕 book' },
      { prompt: '🐱 cat' },
    ],
  },
};
